import { useField } from 'formik';
import { useEffect, useState } from 'react';
import { KoobPlaceAutocomplete } from '@koob/maps';
import { KoobInputText } from '@koob/ui';

export default function SearchablePlaceField({
  name,
  label,
  required,
  block,
  disabled,
}) {
  const [value, , { setValue }] = useField(name);
  const [input, setInput] = useState(null);

  const onPlaceChanged = async (place) => {
    if (place?.geometry) {
      const formattedPlace = {
        name: place.name,
        address: place.formatted_address,
        city:
          place.address_components?.find((c) => c.types.includes('locality'))
            ?.long_name ??
          place.address_components?.find((c) => c.types.includes('postal_town'))
            ?.long_name ??
          place.address_components?.find((c) => c.types.includes('sublocality'))
            ?.long_name ??
          place.address_components?.find((c) =>
            c.types.includes('administrative_area_level_1'),
          )?.long_name,
        country: place.address_components?.find((c) =>
          c.types.includes('country'),
        )?.long_name,
        lat: place.geometry.location.lat(),
        lon: place.geometry.location.lng(),
        isCity: place.types.includes('locality'),
      };

      setValue(formattedPlace);
      setInput(formatPlace(formattedPlace));
    }
  };

  const formatPlace = (p) => {
    const isCity = p.isCity;
    if (isCity || !p.city) {
      return `${p.address}`;
    }
    return `${p.name}, ${p.city}, ${p.country}`;
  };

  useEffect(() => {
    if (value.value && input === null) {
      setInput(formatPlace(value.value));
    }
  }, [value?.value]);

  return (
    <div className={block && 'w-full'}>
      <div className="font-medium mb-2">
        {label}
        <span className="text-red-500">{required ? ' *' : ''}</span>
      </div>
      <KoobPlaceAutocomplete onPlaceSelect={onPlaceChanged}>
        <KoobInputText
          type="text"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          disabled={disabled}
        />
      </KoobPlaceAutocomplete>
    </div>
  );
}
